const styles = theme => ({
  mainBody: {
    background: '#fff',
  },
  container: {
    maxWidth: '1184px',
    [theme.breakpoints.down('sm')]: {
      padding: '0',
    },
  },
  propertyCardHolder: {
    padding: '15px 0',
    // background: '#fff',
  },
  attorneyCardHolder: {
    padding: '15px 0',
    // background: '#fff',
  },
  servicesGridContainer: {
    marginBottom: '16px',
    justifyContent: 'center',
  },
  servicesItem: {
    textAlign: 'center',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '15px',
    maxWidth: '123px',
  },
  serviceIconHolder: {
    marginBottom: '12px',
    overflow: 'hidden',
    minHeight: '63px',
    maxHeight: '63px',
  },
  // recent card css
  propertyCard: {
    overflow: 'hidden',
    boxShadow: '1px 2px 12px rgba(0, 0, 0, 0.1)',
  },
  GridFrame: {
    position: 'relative',
    padding: '25px 0 0',
    cursor: 'pointer',
  },
  properyTextHolder: {
    fontSize: '20px',
    fontWeight: '500',
    marginBottom: '7px',
    '& p': {
      margin: '0',
    },
  },
  recentTextHolder: {
    padding: '12px 16px',
  },
  localtyList: {
    fontSize: '15px',
  },
  dangerLight: {
    margin: '0 0 0 auto',
    color: '#B9350B',
    background: '#FDF0ED',
  },
  location: {
    color: '#8C9099',
    textDecoration: 'none',
    margin: '2px',
  },
  badgeHolder: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    padding: '14px 0 0',
    gap: '10px',
  },
  badgeChip: {
    maxWidth: '100%',
  },
  topBadgeChip: {
    color: '#fff',
    minWidth: '72px',
    borderRadius: '16px 16px 0 0',
    position: 'absolute',
    right: '24px',
    top: '0',
    height: '25px',
    background: '#565960',
    maxWidth: '200px',
  },
  blueLight: {
    background: '#EBF7FF',
    color: '#1270B4',
  },
  WarningMangoLight: {
    background: '#FFFAEB',
    color: '#A76708',
  },
  successGreenLight: {
    background: '#EDFDF9',
    color: '#138266',
  },
  localtyGrid: {
    minWidth: '50%',
    marginBottom: '7px',
  },
  main: {
    minHeight: 'calc(100vh - 310px)',
  },
  alignRight: {
    textAlign: 'right',
  },
  fontWeight500: {
    fontWeight: '500',
  },
  textSize12: {
    fontSize: '12px',
  },
  recentCardimageFrame: {
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },

  errorMessage: {
    marginTop: 30,
  },
  routerLink: {
    textDecoration: 'none',
  },
  // ----------------------------------
  title: {
    fontSize: '16px',
    fontWeight: '600',
  },
  titleHolder: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '15px',
    '& $textDarilight': {
      color: '#8C9099',
      fontSize: '12px',
    },
  },
  textDarilight: {},
  seeAllBtn: {
    textDecoration: 'none',
    fontSize: '12px',
    fontWeight: '500',
    color: '#D2374F',
    minWidth: '50px',
    flexShrink: '0',
  },
  sectMyProperty: {
    background: '#F8F8F8',
    padding: '20px 0 0',
  },
  sectDirectoryGrid: {
    padding: '16px 0',
    '& $imgHolder': {
      margin: '0',
      position: 'relative',
      '& img': {
        maxWidth: '100%',
      },
      '& $mainImg': {
        display: 'block',
        width: '100%',
      },
      '& $rightArrow': {
        position: 'absolute',
        bottom: '16px',
        right: '16px',
      },
      '& $overlay': {
        position: 'absolute',
        left: '0',
        right: '0',
        bottom: '0',
        top: '0',
        display: 'flex',
        alignItems: 'flex-end',
        padding: '24px',
        color: '#fff',
        textDecoration: 'none !important',
        '& p': {
          fontSize: '12px',
        },
        '& $strongText': {
          fontSize: '18px',
          fontWeight: '600',
        },
        '& $icon': {
          marginBottom: '4px',
        },
      },
    },
  },
  imgHolder: {},
  mainImg: {},
  rightArrow: {},
  overlay: {},
  strongText: {},
  icon: {},
  sectRecentProjects: {
    background: '#EBEEF3',
    padding: '10px 0 25px',
  },
  RecentCarouselSlider: {
    [theme.breakpoints.down('sm')]: {
      padding: '0 15px',
    },
  },
  [theme.breakpoints.up('sm')]: {
    titleHolder: {
      padding: '15px 0',
      '& $textDarilight': {
        fontSize: '18px',
      },
    },
    title: {
      fontSize: '24px',
    },
    seeAllBtn: {
      fontSize: '16px',
    },
    propertyCard: {
      display: 'grid',
      gridTemplateColumns: '238px auto',
    },
    servicesGridContainer: {
      justifyContent: 'flex-start',
    },
  },
  [theme.breakpoints.up('md')]: {
    main: {
      padding: '26px 0',
    },
    propertyCardHolder: {
      margin: '0 -14px',
    },
    attorneyCardHolder: {
      margin: '0 -14px',
    },
  },
  [theme.breakpoints.down('sm')]: {
    sectDirectoryGrid: {
      flexWrap: 'nowrap',
      overflow: 'auto',
      margin: '-12px -4px',
      padding: '0 16px 16px',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        width: '0',
        display: 'none',
      },
      '&::-webkit-scrollbar-track': {
        '-webkit-box-shadow': 'none',
        borderRadius: '0',
      },
      '&::-webkit-scrollbar-thumb': {
        '-webkit-box-shadow': 'none',
        borderRadius: '0',
      },
      '& > div': {
        width: '75%',
        flexShrink: '0',
        padding: '12px 4px !important',
      },
    },
  },
});

export default styles;
